import React from 'react'
import { withStyles } from 'material-ui/styles'
import Button from 'material-ui/Button'
import IconButton from 'material-ui/IconButton'

export default withStyles(theme => ({
  toolbar: {
    paddingTop: theme.spacing.unit,
    paddingLeft: theme.spacing.unit,
    paddingRight: theme.spacing.unit
  }
}))(({ classes, ...props }) => (
  <div id="toolbar" className={classes.toolbar} {...props} />
))

export const ToolbarButton = withStyles(theme => ({
  button: {
    margin: theme.spacing.unit
  },
  iconButton: {
    marginBottom: theme.spacing.unit
  },
  floatRight: {
    float: 'right'
  }
}))(({ classes, icon, floatRight, ...props }) => {
  const Component = icon ? IconButton : Button
  const classNames = [
    icon ? classes.iconButton : classes.button,
    floatRight ? classes.floatRight : ''
  ].join(' ')
  return <Component className={classNames} {...props} />
})



// WEBPACK FOOTER //
// ./src/components/Toolbar.js